import React, { PureComponent } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const data = [
  { name: '07 Oct', Vegueta: 1000, Chimbote: 1000, Malabrigo: 1000 },
  { name: '08 Oct', Vegueta: 2000, Chimbote: 1398, Malabrigo: 1210 },
  { name: '09 Oct', Vegueta: 3800, Chimbote: 2800, Malabrigo: 2290 },
  { name: '10 Oct', Vegueta: 4080, Chimbote: 1908, Malabrigo: 2000 },
  { name: '11 Oct', Vegueta: 1890, Chimbote: 4800, Malabrigo: 1181 },
  { name: '12 Oct', Vegueta: 3390, Chimbote: 3800, Malabrigo: 2500 },
  { name: '13 Oct', Vegueta: 3000, Chimbote: 1000, Malabrigo: 2100 },
];

export default class Example extends PureComponent {
  static demoUrl = 'https://codesandbox.io/p/sandbox/stacked-area-chart-forked-5yjhcs';

  render() {
    return (
      <div className="">
        <div className="flex items-center">
            <p className="text-[20px] font-itcmedium text-[#007696] ">Ingreso de Peso Promedio</p>
            <button className="sm:px-[35px]  px-[35px] ml-[17rem] 2xl:ml-[53rem] h-[46px] text-[14px] text-center bg-white border-2 text-[#52526C] rounded-[8px] font-itcmedium border-[#5CBDEB]">
            Filtrar por tiempo
            </button> 
        </div>
        <ResponsiveContainer width="100%" height={400}>
          <AreaChart
            data={data}
            margin={{
              top: 30,
              right: 30,
              left: 20,
              bottom: 0, 
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              padding={{ left: 0, right: 0 }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              type="number"
              domain={[0, 'auto']}
              tickFormatter={(value) => `${value}Kg`} 
              axisLine={false}
              tickLine={false}
            />
            <Tooltip />
            <Legend
              verticalAlign="bottom"
              align="start"
              height={0}
              iconType="circle" 
              iconSize={7}
              formatter={(value) => <span style={{ marginRight: '10px' }}>{value}</span>}
              
            />
            <Area
              type="monotone"
              dataKey="Vegueta"
              stackId="1"
              stroke="#FFC700"
              fill="#FFC7004D"
              fillOpacity={0.1}
              strokeWidth={3}
            />
            <Area
              type="monotone"
              dataKey="Chimbote"
              stackId="1"
              stroke="#76A140"
              fill="#76A1404D"
              fillOpacity={0.1}
              strokeWidth={3}
            />
            <Area
              type="monotone"
              dataKey="Malabrigo"
              stackId="1"
              stroke="#007696"
              fill="#2F2F3B4D"
              fillOpacity={0.1}
              strokeWidth={3}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
